import { useEffect, useRef } from "react";
import { useQuery } from "@apollo/client";
import { GET_AUDIT_PLAN_FILES } from "../../../../apis/settingsApis/audit-apis/auditApis";

const POLL_INTERVAL_MS = 5000;

export const useAuditPlanFiles = (auditId) => {
  const { data, loading, error, refetch } = useQuery(GET_AUDIT_PLAN_FILES, {
    variables: { audit_id: auditId },
    skip: !auditId,
    fetchPolicy: "cache-and-network",
  });

  const auditPlanFiles = data?.getAuditPlanFiles ?? [];

  const pollingRef = useRef(null);
  useEffect(() => {
    const anyProcessing = auditPlanFiles.some(
      (file) => file?.isFileValid === null
    );

    if (anyProcessing) {
      if (!pollingRef.current) {
        pollingRef.current = setInterval(() => {
          refetch();
        }, POLL_INTERVAL_MS);
      }
    } else if (pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    }

    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    };
  }, [auditPlanFiles, refetch]);

  return {
    auditPlanFiles,
    loading,
    error,
    refetch,
  };
};
